import React, { Component } from 'react';
import CategorySelect from './CategorySelect';
import CurrencyInput from '../elements/CurrencyInput';
import Button from './Button';
import TransactionMoneyComponent from '../elements/TransactionMoneyComponent';


export default class TransactionSplitEditComponent extends Component {
	constructor(props) {
		super(props);
		this.editSplitChange = this.editSplitChange.bind(this);
		this.editSplitAmount = this.editSplitAmount.bind(this);
		this.submitTransaction = this.submitTransaction.bind(this);
		this.editSplitChangeCategoryId = this.editSplitChangeCategoryId.bind(this);

		this.state = {
			updating: false,
		};
	}

	editSplitAmount(amount) {
		const { transactionSplit, editSplitAmount } = this.props;
		editSplitAmount(transactionSplit, amount);
	}

	editSplitChange(event) {
		const { transactionSplit, editSplitChange } = this.props;
		editSplitChange(transactionSplit, event);
	}

	editSplitChangeCategoryId(event) {
		const { transactionSplit, editSplitChange } = this.props;
		editSplitChange(transactionSplit, {
			name: 'category_id',
			...event
		});
	}

	submitTransaction(event) {
		const { transaction, transactionSubmit } = this.props;
		if(event.key !== 'Enter') {
			return;
		}
		transactionSubmit(transaction);
	}

	render() {
		const { transactionSplit, categories, transaction, canRemoveSplit, viewOnly, showCategory, categoryEditable } = this.props;
		const { updating } = this.state;

		return (
			<React.Fragment>
				{showCategory &&
				<div className={`category col ${viewOnly ? 's6 m3' : 's7 m4'}`}>
					<CategorySelect
						transactionName={transaction?.where}
						onChange={this.editSplitChangeCategoryId}
						disabled={!!updating}
						name='category_id'
						value={transactionSplit.category_id}
						categories={categories}
						viewOnly={!categoryEditable}
					/>
					{!!transactionSplit.description &&
					<div className='split-description grey-text' title={transactionSplit.description}>
						{transactionSplit.description}
					</div>
					}
				</div>
				}
				<div className={`amount col ${viewOnly ? 's3 offset-s1 offset-m4' : 's5 m5 offset-m1'}`}>
					{viewOnly &&
					<TransactionMoneyComponent
						{...this.props}
						categoryId={transactionSplit.category_id}
						amount={transactionSplit.amount}
					/>
					}
					{!viewOnly &&
					<CurrencyInput
						allowNegative={true}
						onKeyPress={this.submitTransaction}
						onChange={this.editSplitAmount}
						disabled={!!updating}
						type='text'
						name='amount'
						value={transactionSplit.amount}
						label='Amount'
					/>
					}
				</div>
			</React.Fragment>
		);
	}
}